import { CCol, CFormLabel, CFormSelect, CRow } from '@coreui/react-pro'
import { CColProps } from '@coreui/react-pro/dist/components/grid/CCol'
import { CRowProps } from '@coreui/react-pro/dist/components/grid/CRow'
import React from 'react'
import { SelectProps } from '../../types/EmployeeDirectory/EmployeesList/AddNewEmployee/addNewEmployeeType'
import {
  booleanMandatory,
  conditionalDefaultStringEmpty,
  dynamicFormLabelProps,
  showIsRequired,
  StringEmpty,
} from '../../utils/helper'
import { GetList } from '../../types/commonTypes'

const listOptionRenderer = (
  list: GetList[],
  idValue = false,
): JSX.Element[] => {
  return list.map((item, index) => {
    //TODO: Make a refactor change to the below line where the optionName condition is dynamic
    // This condition was only specific for validations in edit emp under joinee and other stuff
    return (
      <option key={index} value={!idValue ? item.name : item.id}>
        {item.name === 'On Contract Hire' ? 'On Contract To Hire' : item.name}
      </option>
    )
  })
}

const OSelect = ({
  dynamicFormLabelProps,
  list,
  setValue,
  value,
  name,
  label,
  placeHolder,
  isRequired,
}: SelectProps): JSX.Element => {
  const onChangeHandler = (e: { target: { value: string } }) => {
    if (setValue == null) return
    setValue(e.target.value)
  }

  const selectedValue = value == null ? '' : value

  return (
    <>
      <CRow className="mb-3">
        <CFormLabel
          data-testid="selectLabel"
          {...dynamicFormLabelProps(
            'technology',
            'col-sm-3 col-form-label text-md-end',
          )}
        >
          {label} :
          {isRequired && (
            <span className={showIsRequired(selectedValue)}>*</span>
          )}
        </CFormLabel>
        <CCol sm={3}>
          <CFormSelect
            id={name}
            size="sm"
            aria-label={label}
            data-testid={`form${name}`}
            name={name}
            value={selectedValue}
            onChange={onChangeHandler}
          >
            <option value={''}>{placeHolder}</option>
            {list?.length > 0 && listOptionRenderer(list)}
          </CFormSelect>
        </CCol>
      </CRow>
    </>
  )
}

//! DO NOT MODIFY IF YOU DON'T KNOW WHAT YOU ARE DOING
//! ONLY MODIFY IF THERE ARE ANY PROPS NEED TO BE ADDED
export const OSelectDynamic = (props: {
  list: GetList[] | { [key: string]: string } | JSX.Element[]
  setValueHandler?: (
    event:
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void
  name: string // its the name, id, data-testid of the select
  label: string

  useIdValueOptions?: boolean
  isRequired?: boolean
  placeHolder?: string
  value?: string
  labelClassName?: string
  selectClassName?: string
  labelColumnType?: CColProps
  selectColumnType?: CColProps
  selectMainColType?: CColProps
  selectMainRowType?: CRowProps
  size?: 'sm' | 'lg'
  ariaLabel?: string
}): JSX.Element => {
  // Default value checks in order not to break the existing code using this component
  const useIdValueOptionsValue = props?.useIdValueOptions ?? false
  const selectedValue = props?.value == null ? '' : props?.value
  const requiredLabel = props?.isRequired ?? false
  const labelColumnTypeValue = props?.labelColumnType ?? {
    sm: { span: 3, offset: 0 },
    lg: { span: 3, offset: 0 },
  }
  const selectColumnType = props?.selectColumnType ?? {
    sm: { span: 3, offset: 0 },
  }

  const renderOptions = () => {
    if (Array.isArray(props.list)) {
      if (props.list.length > 0 && React.isValidElement(props.list[0])) {
        // Handle JSX.Element[]
        return props.list
      } else {
        // Handle GetList[]
        return listOptionRenderer(
          props.list as GetList[],
          useIdValueOptionsValue,
        )
      }
    } else {
      // Handle { [key: string]: string }
      return Object.entries(props.list).map(([value, label]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))
    }
  }

  return (
    <CCol {...props?.selectMainColType}>
      <CRow {...props?.selectMainRowType}>
        <CCol {...labelColumnTypeValue} className="text-md-end">
          <CFormLabel
            data-testid={`selectLabel-${props.name}`}
            {...dynamicFormLabelProps(
              props.label,
              conditionalDefaultStringEmpty(
                props?.labelClassName,
                'col-form-label',
              ),
            )}
          >
            {props?.label ? `${props?.label}: ` : ''}
            {requiredLabel && (
              <span className={booleanMandatory(StringEmpty(selectedValue))}>
                *
              </span>
            )}
          </CFormLabel>
        </CCol>
        <CCol {...selectColumnType}>
          <CFormSelect
            className={props?.selectClassName}
            id={props.name}
            name={props.name}
            data-testid={`formSelect-${props.name}`}
            size={props.size ?? 'sm'}
            aria-label={props?.ariaLabel}
            value={selectedValue}
            onChange={props.setValueHandler}
          >
            <option value={''}>
              {conditionalDefaultStringEmpty(props?.placeHolder, 'Select')}
            </option>
            {renderOptions()}
          </CFormSelect>
        </CCol>
      </CRow>
    </CCol>
  )
}

export default OSelect
